import BusinessCard from './BusinessCard';

interface IMaterialFormLineItem {
    materialItemId?: number;
    quantity?: number;
    businessCard?: BusinessCard;
}

class MaterialFormLineItem implements IMaterialFormLineItem {
    public materialItemId?: number;
    public quantity?: number;
    public businessCard?: BusinessCard;
    private showDetails: boolean = false;


    constructor(m: IMaterialFormLineItem = {}) {
        this.materialItemId = m.materialItemId;
        this.quantity = m.quantity;
        this.businessCard = m.businessCard;
    }

    public get _showDetails(): boolean {
        return this.showDetails;
    }

    public set _showDetails(bool: boolean) {
        this.showDetails = bool;
    }
}

export default MaterialFormLineItem;
export { MaterialFormLineItem, IMaterialFormLineItem };
